export default {
  message: "Hello World"
};



// WEBPACK FOOTER //
// ./src/redux/HelloWorld/state.js